import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Post, CartListURL, RemoveCart, AddToCartURL, ApplyCouponUrl, CouponListUrl, image_url, CountryUrl, StateUrl, CityUrl, AddAddressUrl, ListAddressUrl, RemoveAddrUrl, savebookingUrl } from "../utils/api";
import Header from "./../app/Header";
import { wrapComponent } from 'react-snackbar-alert';
import Button from "./../component/Button";
import { useSelector } from "react-redux";

function Checkout({ refres }) {
    const navigate = useNavigate();

    const [cartItem, setCartItem] = useState([]);
    const [discount, setdiscount] = useState(0);
    const [deliver, setdeliver] = useState(60);
    const [tax, settax] = useState(180);
    const [applyed, setapplyed] = useState('');
    useEffect(() => {
        fetchCartList()
    }, [refres])


    const fetchCartList = () => {
        global.Loader(true)
        let config = {
            url: CartListURL,
        }
        Post(config).then((res) => {
            global.Loader(false)
            if (res.status == true) {
                setCartItem(res?.data)
            }
        }).catch((err) => {
            global.Loader(false)
          //  console.log(err?.response?.data);
        })
    }

    const { cartItems } = useSelector((state) => state);

    const removeItem = ({ id, product_id, variant_id }) => {
        global.Loader(true)
        let config = {
            body: {
                cart_id: id,
                variant_id: variant_id,
                product_id: product_id
            },
            url: RemoveCart,
        }
        Post(config).then((res) => {
            global.Loader(false)
            if (res.status == true) {
                fetchCartList();
                let index = cartItems?.findIndex((v) => v.product_id == id);
                if (index == -1) {
                    cartItems.splice(index, 1);
                    global.dispatch({
                        type: 'CARTITEMS',
                        payload: cartItems
                    })
                }
            }
        }).catch((err) => {
            global.Loader(false)
            console.log(err?.response?.data);
        })
    }

    const calculatePrice = () => {
        let list = [...cartItem];
        let total = 0;
        for (let item of list) {
            total += (item.price * item.quantity)
        }
        return total;
    }

    if (cartItem?.length == 0) {
        return null;
    }


    const truncate = (value, i = 25) => {
        if (value) {
            return `${value.substr(0, i)}...`;
        } else {
            return '';
        }
    }

    return (
        <div style={{
            position: 'fixed',
            zIndex: '999',
            backgroundColor: 'white',
            margin: '10px',
            top: '0px',
            right: '0px',
            overflow: 'scroll',
            borderRadius: '10px',
            boxShadow: '-9px 7px 5px 0px rgba(0,0,0,0.3)',
            // maxHeight:'650px'
        }} className="checkoutbox col-md-3">
            <div className="checkouthead" >
                <div>
                    <span className="ipsum"><i className="fa-solid fa-left-long"></i></span>
                    <h2>Items in cart</h2>
                    <p>Your Cart ₹{calculatePrice()}</p>
                </div>
                <div onClick={() => {
                    setCartItem([]);
                }} style={{ position: 'fixed', top: '6%', right: '50px', fontSize: '25px' }}>
                    <i className="fa-solid fa-xmark"></i>
                </div>
            </div>
            <div className="checkmainarea">
                {cartItem?.map((v, i) => (
                    <div className="itembox">
                        <h3>
                            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                <div><i className="fa-solid fa-circle-info"></i> {truncate(v?.title)}
                                </div>

                                <i onClick={() => {
                                    removeItem(v)
                                }} style={{ color: 'red', marginRight: '20px' }} className="fa-solid fa-trash"></i>
                            </div>
                        </h3>
                        <div className="productmix">
                            <div className="productimg">
                                <img src={`${image_url}${v.image}`} alt="" />
                            </div>
                            <div className="producttext">
                                <h2>{truncate(v?.title, 40)}</h2>
                                {/* <p>30 Capsules</p> */}
                            </div>
                        </div>
                        <div className="productprice">
                            <ul>
                                <li>
                                    Quantity:
                                    <select onChange={({ target }) => {
                                        let items = [...cartItem];

                                        for (let v2 of items) {
                                            if (v2.id == v.id) {
                                                v2.quantity = target.value;
                                                break;
                                            }
                                        }

                                        setCartItem(items);
                                    }} value={v?.quantity} style={{
                                        'backgroundColor': 'transparent',
                                        'border': '0px',
                                    }}>
                                        <option>1</option>
                                        <option>2</option>
                                        <option>3</option>
                                        <option>4</option>
                                        <option>5</option>
                                        <option>6</option>
                                        <option>7</option>
                                        <option>8</option>
                                        <option>9</option>
                                        <option>10</option>
                                    </select>
                                    {/* <i className="fa fa-angle-down" aria-hidden="true"></i>  */}
                                </li>
                                <li>
                                    <b>
                                        <i className="fa fa-inr" aria-hidden="true"></i> {v?.price}
                                    </b>
                                    {/* <s>600</s> */}
                                </li>
                            </ul>
                        </div>
                    </div>
                ))}
                <div className="billarea">
                    <h2>Bill Details</h2>
                    <div className="billdata">
                        <ul>
                            <li>Item Total</li>
                            <li><i className="fa fa-inr" aria-hidden="true"></i>{calculatePrice()}</li>
                        </ul>
                        <ul>
                            <li>Delivery Fee</li>
                            <li><i className="fa fa-inr" aria-hidden="true"></i>{deliver}</li>
                        </ul>
                        <ul>
                            <li>Taxes and Charges</li>
                            <li><i className="fa fa-inr" aria-hidden="true"></i>{tax}</li>
                        </ul>
                        {(applyed != '') &&
                            <ul>
                                <li>Discount ({applyed}) <span style={{
                                    color: 'white',
                                    backgroundColor: 'red',
                                    paddingLeft: '5px',
                                    paddingRight: '5px',
                                    borderRadius: '10px',
                                }} onClick={() => {
                                    setdiscount('');
                                    setapplyed('');
                                }}>Remove</span></li>
                                <li>- <i className="fa fa-inr" aria-hidden="true"></i>{discount}</li>
                            </ul>
                        }
                        <ul style={{ marginBottom: '10px' }}>
                            <li>To Pay</li>
                            <li><i className="fa fa-inr" aria-hidden="true"></i>{parseFloat(calculatePrice()) + deliver + tax - discount}</li>
                        </ul>
                        <Button backgroundColor={'#219653'} onClick={() => {
                            navigate('/checkout')
                        }} title={'Proceed to checkout'} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default wrapComponent(Checkout);


const styles = {
    input: {
        fontFamily: 'Montserrat',
        borderWidth: 0,
        textAlign: 'left',
        backgroundColor: '#CCDDFF',
        width: 410,
        height: 50,
        borderRadius: 10,
        marginBottom: 15,
        paddingLeft: 20,
        marginLeft: 30
    }
}